import { render } from "./ScoreOverview.vue?vue&type=template&id=5d37eaea&scoped=true"
import script from "./ScoreOverview.vue?vue&type=script&lang=js"
export * from "./ScoreOverview.vue?vue&type=script&lang=js"

import "./ScoreOverview.vue?vue&type=style&index=0&id=5d37eaea&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d37eaea"]])

export default __exports__